"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  text: "The $110 flat-rate pricing gave us complete budget predictability during our Series A. Their RMM tools and end-user support are seamless, letting our devs focus on code, not hardware.",
  authorName: "Mark Chen",
  authorRole: "CEO, CloudScale Systems",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/avatar_alexey_smirnov.png",
  companyLogoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/logo_startup_alpha.png"
}, {
  text: "SMB IT Tech isn't just a vendor; they are our fractional IT partners. They truly understand the high-pressure environment of a startup and provide the agility we need to scale fast.",
  authorName: "Sarah Miller",
  authorRole: "Founder, Nexus AI",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/avatar_elena_ivanova.png",
  companyLogoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/logo_design_bureau.png"
}, {
  text: "The transparency on O365 licensing is refreshing. No markups, just expert support included in the flat fee. It's the most honest and efficient IT partnership we've ever experienced.",
  authorName: "James Wilson",
  authorRole: "Ops Director, Fintech Flow",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/avatar_dmitry_volkov.png",
  companyLogoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/logo_volkov_group.png"
}];
export default function PartnerOpinions() {
  return <section data-section-id="224348" id="startup-success-stories" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32"></section>;
}